export default __webpack_public_path__ + "static/media/logo.947fb20f.png";